import { defineMessages } from 'react-intl';

const scope = 'app.workspace.publications';

export default defineMessages({

  search: {
    id: `${scope}.search`,
    defaultMessage: 'Search',
  },

});
